import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { getNewDate } from 'src/utils/date/date-utils';

@Pipe({ name: 'timeDifferenceInDays' })
export class TimeDifferenceInDaysPipe implements PipeTransform {
    transform(
        value: string | number | Date | dayjs.Dayjs | null | undefined,
        otherValue: string | number | Date | dayjs.Dayjs | null | undefined,
        unit?: dayjs.QUnitType | dayjs.OpUnitType,
        precision?: boolean,
    ): number {
        const date = getNewDate(value);
        const date2 = otherValue !== null ? getNewDate(otherValue) : getNewDate();

        return date.diff(date2, unit, precision);
    }
}
